function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.parse-int.js";
import CartController from "./cart-controller";
export default class OfferController extends CartController {
  set offer(value) {
    this._offer = value;
  }

  get offer() {
    return new Promise((resolve, reject) => {
      var value = this._offer;
      value ? resolve(value) : reject({
        message: "The offer HTMLInputElement could not be found."
      });
    });
  }

  set quantity(value) {
    this._quantity = value;
  }

  get quantity() {
    return new Promise((resolve, reject) => {
      var value = this._quantity;
      value ? resolve(value) : reject({
        message: "The quantity HTMLSelectElement could not be found."
      });
    });
  }

  constructor(context) {
    super();
    this.context = void 0;
    this.cart = void 0;
    this._offer = null;
    this._quantity = null;
    this.context = context != null ? context : document;
    this.cart = this.getCart();
    this.offer = this.context.querySelector('input[name="offer"]');
    this.quantity = this.context.querySelector('select[name="quantity"]');
  } // Preselects the offer in the radio group UI based on the customer's cart.


  updateCartOnPageLoad() {
    var _this = this;

    return _asyncToGenerator(function* () {
      var cart = yield _this.cart;
      var offer = yield _this.offer;
      var quantity = yield _this.quantity;
      var item = cart.items.find(i => i.id.toString() === offer.value);

      if (item) {
        quantity.value = item.quantity.toString();
        return;
      }

      _this.updateCart(offer, quantity);
    })();
  } // Shapes the variant id and quantity object to pass into the `/cart/update` endpoint.


  updateCart(offer, quantity) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      _this2.updateItem({
        id: offer.value,
        quantity: parseInt(quantity.value)
      });
    })();
  } // Updates the customer's cart by interacting with the "offers" radio group.


  updateCartOnAction() {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      var offer = yield _this3.offer;
      var quantity = yield _this3.quantity;
      quantity.addEventListener("change", event => _this3.updateCart(offer, quantity));
    })();
  }

}